module.exports = __webpack_public_path__ + "static/media/exclamation-triangle.b2228e2e.svg";